import React from "react";
import * as R from "ramda";
import { Progress } from "antd";

import styled from "styled-components/macro";

const Percentage = styled.div`
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export default function EnglishTest({ t, result }) {
  const score = R.pipe(
    R.values,
    R.median
  )(result);
  const testAreas = { ...result, score };

  return (
    <div>
      {Object.keys(testAreas).map(resultKey => (
        <Percentage key={resultKey}>
          <span data-test={`english-test-${resultKey}`}>
            {t(`opportunity:process.candidateDetails.english.${resultKey}`)} (
            {testAreas[resultKey]}%)
          </span>
          <Progress
            percent={testAreas[resultKey] > 1 ? testAreas[resultKey] : 1}
            showInfo={false}
            strokeColor={R.cond([
              [R.gte(40), R.always("#F5242E")],
              [R.gte(60), R.always("#e0b500")],
              [R.gte(100), R.always("#53C819")]
            ])(testAreas[resultKey])}
          />
        </Percentage>
      ))}
    </div>
  );
}
